import TechRoleSearch from "./TechRoleSearch";
import { TechAreaService } from "../../../services/TechAreaService";
import { useEffect, useState } from "react";
import TechRoleList from "./TechRoleList";
import { TechRoleService } from "../../../services/TechRoleService";

import Pagination from "../../../components/Pagination";
import CreateOrEdit from "./CreateOrEdit";
import TechRoleDelete from "./TechRoleDelete";
export default function TechRolePage() {
  const [searchObject, setSearchObject] = useState({});
  const [techAreas, setTechAreas] = useState([]);
  const [techRoles, setTechRoles] = useState([]);
  const [isOpenCreatOrEdit, setIsOpenCreatOrEdit] = useState(false);
  const [techRoleId, setTechRoleId] = useState();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [techRole, setTechRole] = useState({});

  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 20;
  const [totalPages, setTotalPages] = useState(0);
  useEffect(() => {
    getTechAreas();
  }, []);
  useEffect(() => {
    getTechRoles();
  }, [searchObject, pageNumber]);
  function getTechRoles() {
    TechRoleService.getAll(pageSize, pageNumber, searchObject).then((data) => {
      setTechRoles(data.page);
      setTotalPages(Math.ceil(data.total / pageSize));
    });
  }
  function getTechAreas() {
    TechAreaService.getAllTechAreas().then((data) => {
      setTechAreas(data.page);
    });
  }
  function onChange({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }
  function onCloseCreateOrEdit() {
    setIsOpenCreatOrEdit(false);
    setTechRoleId();
    getTechRoles();
  }
  function setEdit(id) {
    setIsOpenCreatOrEdit(true);
    setTechRoleId(id);
  }
  function setForDelete(techRole) {
    setTechRole(techRole);
    setIsDeleteOpen(true);
  }
  function onCloseDelete() {
    setIsDeleteOpen(false);
    setTechRole({});
    getTechRoles();
  }
  return (
    <>
      <div className="row">
        <div className="col">
          <TechRoleSearch
            onChange={onChange}
            searchObject={searchObject}
            techAreas={techAreas}
          />
        </div>
        <div className="col text-end">
          <button
            className="app-button btn-prime btn-md"
            onClick={() => setIsOpenCreatOrEdit(true)}
          >
            <i class="bi bi-plus-lg"></i>
          </button>
        </div>
      </div>
      <TechRoleList
        searchObject={searchObject}
        setSearchObject={setSearchObject}
        list={techRoles}
        techRoleId={techRoleId}
        setCreateOrEdit={setEdit}
        setForDelete={setForDelete}
      />
      <Pagination
        totalPages={totalPages}
        setPageNumber={setPageNumber}
        pageNumber={pageNumber}
      />
      <CreateOrEdit
        onClose={onCloseCreateOrEdit}
        isOpen={isOpenCreatOrEdit}
        techRoleId={techRoleId}
        techAreas={techAreas}
      />
      <TechRoleDelete
        onClose={onCloseDelete}
        isOpen={isDeleteOpen}
        techRole={techRole}
      />
    </>
  );
}
